<template>
  <main>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 -text-weight-medium">{{ titulo }}</p>
    </div>
    <section class="row items-center text-brand-5 -text-weight-bold">
      <div class="row items-center">
        <div class="container">
          <label class="btn-adicionar" for="arquivo"> Selecionar Arquivo</label>
          <div class="text-brand-5 text-weight-bold text">
            {{ file ? file.name : "Nenhum arquivo escolhido" }}
          </div>
          <input id="arquivo" type="file" @change="onFileSelected" />
          <span class="icon">
            <img src="../../../assets/file_upload_white.svg" alt="" />
          </span>
        </div>

        <div
          class="col-md-3 q-ml-sm col-sm-8 col-xs-8 text-brand-5 text-weight-bold"
        >
          Descrição do Documento

          <input type="text" class="comentarioUP" />
        </div>

        <div class="q-pl-sm q-pt-sm" style="margin-top: 2px">
          <q-btn
            class="full-width"
            color="positive"
            label="Enviar"
            no-caps
            icon="check_circle_outline"
            @click="enviarPlanilha"
          />
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
export default {
  props: ["titulo", "template", "transaction_uuid"],
  setup(props) {
    const file = ref(null);

    const store = useStore();
    const $q = useQuasar();

    let onFileSelected = async (e) => {
      if (e.target.files[0].length === 0) {
        return;
      }
      file.value = e.target.files[0];
    };

    const enviarPlanilha = async () => {
      if (file.value == null || file.value == "null") {
        $q.notify({
          message: "Selecione alguma planilha",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      } else if (
        file.value.type.split("/")[1] != "pdf" &&
        file.value.type.split("/")[0] != "image"
      ) {
        $q.notify({
          message: "Tipo de arquivo, não aceito",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      } else if (props.transaction_uuid == "") {
        $q.notify({
          message: "Filtre um funcionario antes de enviar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      var reader = new FileReader();
      reader.readAsDataURL(file.value);
      reader.onload = async function () {
        try {
          let comentario = await document.querySelector(".comentarioUP").value;

          await store.dispatch("fer/uploadCautela", {
            observacao: comentario,
            imagem: reader.result,
            transaction_uuid: props.transaction_uuid,
          });

          $q.notify({
            message: "Arquivo enviado!",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          file.value = null;
        } catch (error) {
          $q.notify({
            message: "Erro ao enviar arquivo, confira se preencheu descrição",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          console.log(error);
        }
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
    };

    return {
      file,
      enviarPlanilha,
      onFileSelected,
    };
  },
};
</script>

<style scoped>
input[type="file"] {
  display: none;
}
.btn-adicionar {
  display: inline-block;
  background-color: #58afc1;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  margin: 5px 5px 0 0;
  padding: 6px 20px;
  padding-left: 40px;
}
.text {
  display: inline;
}
.container {
  position: relative;
}
.icon {
  position: absolute;
  top: 9px;
  left: 9px;
}

.comentarioUP {
  width: 100%;
  height: 40px;

  outline-color: #58afc1;
}
</style>
